document.querySelectorAll('.filters').forEach(filtersContainer => {
  const filterClose = filtersContainer.querySelectorAll('.close-filter');
  const filterPanel = filtersContainer.querySelectorAll('.filter-panel');
  const filterToggle = filtersContainer.querySelectorAll('#filter-toggle');

  filterToggle.forEach(toggle => {
    toggle.addEventListener('click', () => {
      filterPanel.forEach(panel => {
        panel.classList.toggle('active');
      });
    });
  });

  filterClose.forEach(close => {
    close.addEventListener('click', () => {
      filterPanel.forEach(panel => {
        panel.classList.remove('active');
      });
    });
  });
});
